const primary = '#3f97d2';

export default {
  primary,
}
